import { useNavigate, useLocation, useParams } from 'react-router-dom';

/**
 * Legacy withRouter compatibility wrapper for React Router v6
 * Provides history, location, and match props to class components
 */
export const withRouterV6 = (Component) => {
  return (props) => {
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();

    const history = {
      push: (path, state, relative) => navigate(path, { state, relative }),
      replace: (path, state) => navigate(path, { replace: true, state }),
      go: (n) => navigate(n),
      goBack: () => navigate(-1),
      goForward: () => navigate(1),
    };

    const match = {
      params,
      // Add other match properties as needed
    };

    return (
      <Component
        {...props}
        history={history}
        location={location}
        match={match}
      />
    );
  };
};
